<div class="modal-details-container ">
    <!-- Header -->
    <div class="modal-header">
        <div class="modal-title objectives-details-title" cvLocalizedText langSection="Objectives" langKey="Objectives_Details" >Objectives Details</div>
        <button type="button" class="icon-btn fill-iconDefault modal-close" (click)="onCancelClicked()">
            <svg class="icon-12">
                <use href="../App_Themes/CXone/icons/close.svg#close"></use>
            </svg>
        </button>
    </div>
    <!-- Loading Graphic -->
    <cv-loader [hidden]="data" [overlay]="true" class="objectives-details-loader-container"></cv-loader>
    <!-- Modal Body -->
    <div *ngIf="data" class="objectives-details-content-container">
            <div  *ngIf="groupInfo" class="row d-flex align-items-start" style="margin-bottom: 16px;">
                <span class="objectives-details-subtitle col-4">{{ data.CompanyGroupTypeName }}</span>
                <span class="objectives-details-content col-8">{{ groupInfo.groupName }}</span>
            </div>
            <div class="row d-flex align-items-start" style="margin-bottom: 16px;">
                <span class="objectives-details-subtitle col-4" cvLocalizedText langSection="Objectives" langKey="Current_Result" >Current Result</span>
                <span class="objectives-details-content" [style.backgroundColor]="metricData.objectiveData.poValueRgbaColor" style="margin-left: 15px;">{{ metricData.MetricDisplayValue }}</span>
            </div>
            <div class="row d-flex align-items-start" style="margin-bottom: 16px;">
                <span class="objectives-details-subtitle col-4" cvLocalizedText langSection="Common" langKey="Metric" >Metric</span>
                <span class="objectives-details-content col-8">{{ metricName }}</span>
            </div>
            <div class="row d-flex align-items-start" style="margin-bottom: 16px;">
                <span class="objectives-details-subtitle col-4" cvLocalizedText langSection="Objectives" langKey="Type" >Type</span>
                <span class="objectives-details-content col-8">{{ getMetricObjectiveTypeString() }}</span>
            </div>
            <div class="row d-flex align-items-start" style="margin-bottom: 16px;">
                <span class="objectives-details-subtitle col-4" cvLocalizedText langSection="Objectives" langKey="Direction" >Direction</span>
                <span class="objectives-details-content col-8">{{ getMetricObjectiveDirectionString()}}</span>
            </div>
            <div class="row d-flex align-items-start" style="margin-bottom: 16px;">
                <span class="objectives-details-subtitle col-4" cvLocalizedText langSection="Objectives" langKey="Ranges" >Ranges</span>
                <cv-interactive-bar
                    *ngIf="barData"
                    class="mt-5 ml-1 col-12"
                    [data]="barData"
                    [forceStatusBreakdownView]="true">
                </cv-interactive-bar>
            </div>
            <div class="row d-flex align-items-start" style="margin-bottom: 16px;">
                <span class="objectives-details-subtitle col-12" cvLocalizedText langSection="Objectives" langKey="Employee_Groups" >Employee Group(s)</span>
                <div class="mt-3 ml-1 col-12" style="position: relative;">
                    {{ newEmployeeGroups }}
                    <div *ngIf="!showMoreEmployeeGroups && !data.Assignments.empAssignAll && newEmployeeGroups.length >= MAX_CHARACTERS_GROUPS" class="see-more-less-element">
                        <div class="color-cerulean clickable body-2" (click)="expandEmpGroupList()"
                            cvLocalizedText langSection="Objectives" langKey="See_More">See more</div>
                    </div>
                    <div *ngIf="showMoreEmployeeGroups && !data.Assignments.empAssignAll" class="see-more-less-element">
                        <div class="color-cerulean clickable body-2" (click)="expandEmpGroupList()"
                            cvLocalizedText langSection="Objectives" langKey="See_Less">See less</div>
                    </div>
                </div>
                <span class="objectives-details-subtitle mt-2 col-12" cvLocalizedText langSection="Objectives" langKey="Call_Groups" >Call Group(s)</span>
                <div class="mt-3 ml-1 col-12"  style="position: relative;">
                    {{ newCallGroups }}
                    <div *ngIf="!showMoreCallGroups && !data.Assignments.recAssignAll && newCallGroups.length >= MAX_CHARACTERS_GROUPS" class="see-more-less-element">
                        <div class="color-cerulean clickable body-2" (click)="expandCallGroupList()"
                            cvLocalizedText langSection="Objectives" langKey="See_More">See more</div>
                    </div>
                    <div *ngIf="showMoreCallGroups && !data.Assignments.recAssignAll" class="see-more-less-element">
                        <div class="color-cerulean clickable body-2" (click)="expandCallGroupList()"
                            cvLocalizedText langSection="Objectives" langKey="See_Less">See less</div>
                    </div>
                </div>
            </div>
    </div>
    <div class="modal-footer footer"></div>
</div>
